import * as React from "react";
import styled from "styled-components";

import { Button } from "src/library/components/Button";
import { Input } from "src/library/components/Forms";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { formatPrice } from "src/core/prices/utils/price-helpers";

interface PriceChangeFormProps {
  price: number;
  onSubmit: (price: number) => void;
  updating: boolean;
  disabled?: boolean;
}

const PriceChangeForm: React.ReactFCWithChildren<PriceChangeFormProps> = props => {
  const [ price, changePrice ] = React.useState<string>(formatPrice(props.price));
  const [ showConfirm, setShowConfirm ] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (parseFloat(price) !== props.price) {
      setShowConfirm(true);
    } else {
      setShowConfirm(false);
    }
  }, [ price ]);

  React.useEffect(() => {
    setShowConfirm(false);
  }, [ props.updating ]);

  return (
    <PriceChangeWrapper>
      <Input
        loading={props.updating}
        Prepend="£"
        name="priceChange"
        inputType="number"
        label=""
        as="input"
        disabled={props.disabled ? props.disabled : false}
        handleChange={e => changePrice(e.target.value)}
        value={price}
      />

      {showConfirm && (
        <Button
          loading={props.updating}
          onClick={() => {
            const newPrice = formatPrice(price);

            changePrice(newPrice);
            props.onSubmit(parseFloat(newPrice));
          }}
        >
          <Icon
            $fillColor="white"
            icon={Icons.TICK}
          />
        </Button>
      )}
    </PriceChangeWrapper>
  );
};

const PriceChangeWrapper = styled.div`
  display: flex;
  position: relative;
`;

export default PriceChangeForm;
